import config from "@/config"
import http from "@/utils/request"

export default {
	uploadVideo: {
		url: `${config.API_URL}/user/uploadVideo`,
		name: "视频上传",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	uploadAudio: {
		url: `${config.API_URL}/user/uploadAudio`,
		name: "音频上传",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

    getInfo: {
		url: `${config.API_URL}/user/getInfo`,
		name: "获取用户信息",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

    exchangeCdk: {
		url: `${config.API_URL}/user/exchangeCdk`,
		name: "CDk 兑换",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

    getPointLog: {
		url: `${config.API_URL}/user/getPointLog`,
		name: "获取用户信息",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

    uploadImage: {
		url: `${config.API_URL}/user/uploadBase64Image`,
		name: "图片上传",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
}
